import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CheckNullUndefinedService } from './check-null-undefined.service';

@Injectable({
  providedIn: 'root'
})
export class DateTransformService {
  datePipe = new DatePipe("en-US");
  data: any;
  constructor(private checkNullUndefinedService: CheckNullUndefinedService) { }

  transFormDate(value: any) {
    if (this.checkNullUndefinedService.checkNullAndUndefinedWithBlank(value)) {
      this.data = this.datePipe.transform(value, 'dd-MM-yyyy hh:mm:ss a');
      return this.data;
    }
    return "";
  }

  transFormDateWithout(value: any) {
    if (this.checkNullUndefinedService.checkNullAndUndefinedWithBlank(value)) {
      this.data = this.datePipe.transform(value, 'dd-MM-yyyy');
      return this.data;
    }
    return "";
  }

  transFormDateOnly(value: any) {
    if (this.checkNullUndefinedService.checkNullAndUndefinedWithBlank(value)) {
      this.data = this.datePipe.transform(value, 'yyyy-MM-dd');
      return this.data;
    }
    return "";
  }

  transFormTimeOnly(value: any) {
    if (this.checkNullUndefinedService.checkNullAndUndefinedWithBlank(value)) {
      this.data = this.datePipe.transform(value, 'HH:mm');
      return this.data;
    }
    return "";
  }
}
